import React from 'react';
import { Card, CardContent, Skeleton, Stack } from '@mui/material';

function SectionSkeleton({ lines = 3 }: { lines?: number }) {
  return (
    <Card variant="outlined" sx={{ borderRadius: 3 }}>
      <CardContent>
        <Skeleton variant="text" width="32%" height={32} />
        <Skeleton variant="text" width="58%" height={22} sx={{ mb: 1.5 }} />
        <Stack spacing={1}>
          {Array.from({ length: lines }, (_, index) => (
            <Skeleton key={index} variant="rounded" height={18} width={`${88 - index * 8}%`} />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}

type ArtifactDetailSectionsSkeletonProps = {
  sectionCount?: number;
};

export const ArtifactDetailSectionsSkeleton: React.FC<ArtifactDetailSectionsSkeletonProps> = ({
  sectionCount = 5,
}) => (
  <Stack spacing={3} data-testid="artifact-detail-sections-skeleton">
    {Array.from({ length: sectionCount }, (_, index) => (
      <SectionSkeleton key={index} lines={index % 2 === 0 ? 4 : 3} />
    ))}
  </Stack>
);

export default ArtifactDetailSectionsSkeleton;
